import { render, staticRenderFns } from "./AccettazioneSsnRicettaDettaglioComponent.vue?vue&type=template&id=4d6d7924&scoped=true"
import script from "./AccettazioneSsnRicettaDettaglioComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnRicettaDettaglioComponent.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneSsnRicettaDettaglioComponent.vue?vue&type=style&index=0&id=4d6d7924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d7924",
  null
  
)

export default component.exports